import Api from "@/services/Api";
import helpers from "@/helpers.js";

export default {
    async getAttributes(related_entity) {
        var attribute_list = []
        await Api(true).post("attribute/attribute_list", {related_entity: related_entity})
        .then(r => {
            attribute_list = r.data.map(e => {
                e.id = e.guid
                e.label = e.name
                e.collapsed = true
                return e
            }),
            "id"
        })
        return attribute_list
    },

    async getAttributeTree(flat_list, relation) {
        return helpers.toTree(flat_list, relation)
    },

    async getAttributeTypeList() {
        var attribute_types = []
        await Api(true).post("attribute_type/attribute_type_list", {})
        .then(r => {
            attribute_types = r.data
        })
        return attribute_types
    },

    async getAttributeProcess(attribute, mode, related_entity) {

        await Api(true).post(
            mode == "add"
            ? "attribute/create/" + related_entity
            : "attribute/edit/" + related_entity, 
            attribute
        )     
        .then(r => {
        attribute = r.data
        })
        
        return attribute
    },

    async listCategoryOptions({ category_id, attribute_id }) {
        const r = await Api(true).post("attribute/category-options/list", {
            category_id,
            attribute_id,
        });
        return r.data || [];
    },

    async createCategoryOption({ category_id, attribute_id, name }) {
        const r = await Api(true).post("attribute/category-options/create", {
            category_id,
            attribute_id,
            name,
        });
        return r.data;
    },

    async renameCategoryOption({ guid, name }) {
        const r = await Api(true).post("attribute/category-options/rename", {
            guid,
            name,
        });
        return r.data;
    },

    async updateCategoryAttributeMeasuringUnit(payload) {
        const r = await Api(true).post("attribute/category-attribute/measuring-unit", payload);
        return r.data;
    },
}